import axios from "axios";
import { useAuthStore } from "../../stores/stores";
import { message } from "antd";
import { generateRequestHash } from "../../utils/hashSha256";

export const BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const axiosConfigToUpload = axios.create({
  baseURL: BASE_URL,
  timeout: 55000,
  withCredentials: true,
  headers: {
    "content-type": "multipart/form-data",
    ...(localStorage.getItem("browserExamKey")
      ? {
          "x-safeexambrowser-requesthash":
            localStorage.getItem("browserExamKey"),
        }
      : {}),
  },
});

axiosConfigToUpload.interceptors.request.use(
  async (config) => {
    const accessToken = useAuthStore.getState().accessToken;
    if (!config.headers["Authorization"] || accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const isSeb = navigator.userAgent.includes("SEB");
    if (isSeb) {
      try {
        const fullUrl = config.baseURL
        ? `${config.baseURL.replace(/\/$/, "")}${config.url}`
        : config.url || "";
        
        const hashKey = await generateRequestHash(fullUrl);

        if(hashKey) {
          config.headers["X-SafeExamBrowser-RequestHash"] = hashKey;
        }
      } catch (err) {
        console.error("Không thể thêm SafeExamBrowser hash:", err);
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosConfigToUpload.interceptors.response.use(
  (response) => response,
  async (error) => {
    const prevRequest = error?.config;
    if (error?.response?.status === 403 && !prevRequest?.sent) {
      prevRequest.sent = true;
      try {
        const refreshToken = useAuthStore.getState().refreshToken;
        const accessToken = useAuthStore.getState().accessToken;
        if (refreshToken && accessToken) {
          prevRequest.headers["Authorization"] = `Bearer ${accessToken}`;
          return axiosConfigToUpload(prevRequest);
        }
      } catch (error) {
        location.replace("/login");
      }
    } else if (error?.response?.status === 400) {
      message.error(error.response.data.message);
    } else if (error?.response?.status === 401) {
      // unauthorize
      const logout = useAuthStore.getState().logout;
      logout();
      return Promise.reject(error);
    } else if (error?.response?.status === 503) {
      //server down
      const logout = useAuthStore.getState().logout;
      logout();
      return Promise.reject(error);
    } else if (error?.response?.status === 500) {
      message.error(
        error.response.data.message ||
          "Hệ thống bị gián đoạn vui lòng quay lại sau."
      );
    }
    return Promise.reject(error);
  }
);
